import React from "react";
import { useDropzone } from "react-dropzone";
import { useDispatch, useSelector } from "react-redux";
import uuid from "uuid";

import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { Button, Typography, makeStyles, Grid } from "@material-ui/core";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";

import {
  addCompanionCreatives,
  addDimensions,
} from "../../../actions/app/creatives";
import CreativeDialog from "../../Shared/AssignedCreativesDialog/CreativeDialog";

const useStyles = makeStyles((theme) => ({
  typography: {
    paddingBottom: 24
  }
}));

const creativeTypes = ["DISPLAY"];

const CompanionCreative = ({
  selectedIds,
  deselectCards,
  selectedCreatives,
  setSelectedCreatives,
  placements
}) => {
  let dispatch = useDispatch();
  let creatives = useSelector((state) => state.creatives);
  let classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDrop = (acceptedFile) => {
    setAnchorEl(null);
    let file = acceptedFile[0];
    let id = uuid.v4();
    let reader = new FileReader();

    reader.onload = function (e) {
      // Only extract dimensions for image files
      if (file.type && file.type.startsWith('image/')) {
        let img = new Image();
        img.src = e.target.result;

        img.onload = function () {
          let dimensions = this.width + " x " + this.height;
          // Don't pass selectedIds — companion dimensions should not
          // overwrite the primary media creative's dimensions
          dispatch(addDimensions(id, dimensions));
        };
      } else {
        dispatch(addDimensions(id, "N/A"));
      }
    };

    reader.readAsDataURL(file);

    let companionCreative = {
      id,
      file: file,
      preview: URL.createObjectURL(file),
      weight: 0,
      taxonomy: {
        name: "",
        dimensions: ""
      }
    };
    dispatch(addCompanionCreatives(selectedIds, companionCreative));
    deselectCards();
  };

  let isUploadDisabled = () => {
    if (selectedIds.length === 0) return true;
    for (let selectedId of selectedIds) {
      let selectedCreative = creatives.byId[selectedId];
      // Disable for non-media creatives (companions are for audio and video)
      if (selectedCreative.file && selectedCreative.file.type &&
          !selectedCreative.file.type.startsWith('audio/') &&
          !selectedCreative.file.type.startsWith('video/')) {
        return true;
      }
      if (selectedCreative.dcmId) return true;
      if (selectedCreative.companionId) return true;
    }
    return false;
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*, .zip",
    onDrop: handleDrop,
    multiple: false
  });

  return (
    <Grid container>
      <Grid item xs={12}>
        <Typography
          variant="body1"
          className={classes.typography}
          color="textSecondary"
        >
          Select one or more media creatives from left to add companion creatives
        </Typography>
        <Typography
          variant="body1"
          className={classes.typography}
          color="textSecondary"
        >
          Companions are image or HTML5 assets displayed alongside the media player
        </Typography>
      </Grid>
      <Grid item>
        <Button
          color="secondary"
          onClick={handleClick}
          variant="contained"
          disabled={isUploadDisabled()}
          disableElevation
          endIcon={<ArrowDropDownIcon />}
        >
          Add Companion Creative
        </Button>
        <Menu
          id="companion-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
          transformOrigin={{
            vertical: -45,
            horizontal: "left"
          }}
        >
          <div {...getRootProps()}>
            <MenuItem>
              <input {...getInputProps()} />
              Upload new creative
            </MenuItem>
          </div>
          {!isUploadDisabled() && (
            <MenuItem onClick={handleClickOpen}>
              Assign existing creative
            </MenuItem>
          )}
        </Menu>
      </Grid>
      <CreativeDialog
        companion={true}
        open={open}
        setOpen={setOpen}
        creativeTypes={creativeTypes}
        selectedCreatives={selectedCreatives}
        setSelectedCreatives={setSelectedCreatives}
        selectedIds={selectedIds}
        deselectCards={deselectCards}
        handleCloseMenu={handleClose}
        placements={placements}
      />
    </Grid>
  );
};

export default CompanionCreative;
